import script from "./AppointmentPaymentResult.vue?vue&type=script&setup=true&lang=js"
export * from "./AppointmentPaymentResult.vue?vue&type=script&setup=true&lang=js"

import "./AppointmentPaymentResult.vue?vue&type=style&index=0&id=2824f3fb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2824f3fb"]])

export default __exports__